import { render } from "./waves-border.vue?vue&type=template&id=63d90c50&scoped=true"
import script from "./waves-border.vue?vue&type=script&lang=js"
export * from "./waves-border.vue?vue&type=script&lang=js"

import "./waves-border.vue?vue&type=style&index=0&id=63d90c50&lang=scss&scoped=true"

import exportComponent from "/home/gebruiker/www/profs-computers/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-63d90c50"]])

export default __exports__